<template>
    <div>
        <div>
            <JJModal ref="jjModal" v-show="isModalVisible" :modalType="modalType" @close="closeModal" :modalTypes="modalTypes"></JJModal>
            <!-- <JJModal ref="jjModal"></JJModal> -->
            <div class="jj-header">
                <div class="jj-header-left">
                </div>
                <div class="jj-header-right">
                </div>
                <div class="jj-logo">
                    <img src="../../../../assets/images/jj_logo_2020.png" @click="jjHome()">
                </div>
            </div>

            <div v-if="view == pageView.jj_signup">
                <div class="jj-signup-container">
                    <JJSignup @signupFormSaves="signupFormSaved"></JJSignup>
                </div>
            </div>

            <div v-else-if="view == pageView.update_payment" style="margin-bottom:100px;">
                <div class="logout-container" v-if="userAuthenticated"><span class="logout-email">{{userInfo.email}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="logout-link" @click="logout()">Logout</span></div>
                <LoginByStoreNumber v-if="!userAuthenticated" @userLoggedIn="userLoggedIn" class="login-by-store-number"></LoginByStoreNumber>
                <JJUpdatePayment v-else :userInfo="userInfo" class="update-payment"></JJUpdatePayment>
            </div>

            <div v-else>
                <div v-if="signupFormHasBeenSaved" class="alert alert-success" role="alert">
                    Success: signup form has been saved
                </div>
                <div v-if="paymentFormHasBeenSaved" class="alert alert-success" role="alert">
                    Success: payment method has been saved
                </div>
                <div class="jj-main-container">
                    <div class="signup-container" @click="view = pageView.jj_signup">
                        <router-link :to="{ path: '/jimmyjohns/jj_signup' }">
                            <img src="../../../../assets/images/JJ-signup.png">
                        </router-link>
                    </div>
                </div>

                <div class="quad-container">
                    <div class="row">
                        <div class="quad-card left" @click="view = pageView.update_payment">
                            <router-link :to="{ name: 'update_payment' }">
                                <img src="../../../../assets/images/JJ-update-payment.png">
                            </router-link>
                        </div>
                        <div class="quad-card right" @click="popModal(modalTypes.pcRequirements)">
                            <img src="../../../../assets/images/JJ-pc-requirements.png">
                        </div>
                    </div>
                    <div class="row">
                        <div class="quad-card left" @click="popModal(modalTypes.installation)">
                            <img src="../../../../assets/images/JJ-installation.png">
                        </div>
                        <div class="quad-card right" @click="popModal(modalTypes.troubleshooting)">
                            <img src="../../../../assets/images/JJ-troubleshoot.png">
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="footer">
            <a class="service-terms" href="/setup_guides/JJTerms.pdf" target="_blank">
                SERVICE TERMS AND CONDITIONS
            </a>
            <div class="jj-white"><img src="../../../../assets/images/jj_white_icon.png"></div>
            <div class="jj-help"><a href="mailto:jjsupport@theplaylistgeneration.com"><i class="far fa-question-circle"></i></a></div>
        </div>

    </div>

</template>

<script>
import JJUpdatePayment from './JJUpdatePayment.vue';
import JJModal from './JJModal.vue';
import LoginByStoreNumber from '../../Auth/LoginByStoreNumber.vue';
import JJSignup from './JJSignup.vue';
import { initCrispForUser, resetCrispSession } from '@/services/crispChat.js';

export const PageViews = {
  update_payment: 0,
  payment_update_success: 1,
  jj_signup: 2,
  signup_success: 3,
  splash: 4,
};

export const ModalTypes = {
  installation: 1,
  troubleshooting: 2,
  pcRequirements: 3,
};

export default {
  components: {
    JJUpdatePayment,
    LoginByStoreNumber,
    JJSignup,
    JJModal,
  },
  data() {
    return {
      view: PageViews.splash,
      userAuthenticated: false,
      userInfo: '',
      signupFormHasBeenSaved: false,
      paymentFormHasBeenSaved: false,
      messageTimer: '',
      isModalVisible: false,
      modalType: '',
      pageView: PageViews,
      modalTypes: ModalTypes,
    };
  },
  mounted() {
    this.checkRoute();
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      let access_token = localStorage.getItem('si_access_token');
      access_token = (typeof (access_token) === 'undefined') ? null : access_token;

      if (access_token) {
        this.userAuthenticated = true;
        // FetchUser Info
        this.fetchUserInfo();
      } else {
        this.userAuthenticated = false;
      }
    },
    fetchUserInfo() {
      const self = this;
      this.$http.get('/user').then((response) => {
        self.userInfo = response.data;
        if (response.data.message == 'Unauthenticated.') {
          localStorage.removeItem('si_access_token');
          self.userAuthenticated = false;
          self.userInfo = {};
          resetCrispSession();
        } else {
          initCrispForUser(response.data);
        }
      },
      () => {
        // If there was no response, there was an issue so logout and remove all user info
        self.logout();
      });
    },
    signupFormSaved() {
      this.signupFormHasBeenSaved = true;
    },
    popModal(type) {
      this.modalType = type;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    jjHome() {
      this.$router.push({ name: 'jj_main' });
    },
    checkRoute() {
      const route = this.$route;
      const routeSplit = route.path.split('/');
      this.signupFormHasBeenSaved = false;

      if (routeSplit && routeSplit[1]) {
        this.handleRoute(routeSplit[1]);
      } else {
        this.handleRoute();
      }

      // Always scroll to the top of the page
      const container = this.$el.querySelector('.jj-header');
      container.scrollTop = container.scrollHeight;
    },
    handleRoute(route) {
      if (route == 'update_payment') {
        this.view = PageViews.update_payment;
      } else if (route == 'payment_update_success') {
        this.view = PageViews.splash;
        this.paymentFormHasBeenSaved = true;
        clearInterval(this.messageTimer);
        this.messageTimer = setInterval(this.removeFormSavedMessage, 8000);
      } else if (route == 'jj_signup') {
        this.view = PageViews.jj_signup;
      } else if (route == 'signup_success') {
        this.view = PageViews.splash;
        this.signupFormHasBeenSaved = true;
        clearInterval(this.messageTimer);
        this.messageTimer = setInterval(this.removeFormSavedMessage, 8000);
      } else {
        this.view = PageViews.splash;
      }
    },
    removeFormSavedMessage() {
      this.signupFormHasBeenSaved = false;
      this.paymentFormHasBeenSaved = false;
      clearInterval(this.messageTimer);
    },
    userLoggedIn() {
      this.userAuthenticated = true;
      this.fetchUserInfo();
    },
    logout() {
      resetCrispSession();
      this.userAuthenticated = false;
      localStorage.removeItem('si_access_token');
      this.userInfo = '';
      this.jjHome();
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    },
    isModalVisible() {
      if (this.isModalVisible) {
        document.body.classList.add('noscroll');
      } else {
        document.body.classList.remove('noscroll');
      }
    },
  },
  props: [],
};
</script>

<style scoped>
body {
    padding: 0px;
    color: black;
    padding-bottom: 50px;
}

.jj-header {
    width: 100%;
    padding: 0px;
    height: 75px;
}

.jj-header-left {
    width: 50%;
    height: 100%;
    background: rgb(224, 0, 43);
    float: left;
}

.jj-header-right {
    width: 50%;
    height: 100%;
    background: black;
    float: right;
}

.jj-logo {
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -55px;
    cursor: pointer;
}

.jj-red {
    color: rgb(224, 0, 43);
}

.jj-logo img {
    width: 110px;
    height: auto
}

.signup-container {
    width: 900px;
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 30px;
    transition: .3s;
    clear: both;
}

.signup-container img {
    width: 100%;
    height: auto;
}

.signup-container img:hover {
    opacity: .85;
}

.jj-signup-container {
    max-width: 800px;
    margin: 0 auto;
    margin-top: 30px;
    color: black;
    clear: both;
    padding-top: 30px;
}

.jj-main-container {
    margin-top: 30px;
    color: black;
    clear: both;
}

.main-description {
    text-align: center;
    margin-bottom: 30px;
    font-size: 110%;
    width: 400px;
    margin: 0 auto;
    margin-bottom: 30px;
}

.quad-container {
    max-width: 800px;
    height: auto;
    margin: 0 auto;
    padding-bottom: 100px;
    margin-top: 20px;
}

.quad-card {
    color: black;
    width: calc(50% - 10px);
    height: auto;
    padding: 20px;
    margin: 3px;
    cursor: pointer;
    transition: .3s;
}

.quad-card img {
    width: 100%;
    height: auto;
}

.left {
    float: left;
}

.right {
    float: right;
}

.quad-card img {
    width: 100%;
    height: auto;
}

.quad-card:hover>.quad-card-icon {
    color: rgb(224, 0, 43);
}

.sub-section {
    width: 220px;
    clear: both;
    margin: 0 auto;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 2px;
    padding: 5px;
    transition: .1s;
    margin-top: 3px;
}

.sub-section-content a {
    color: blue;
    text-decoration: underline;
    width: 500px;
}

.sub-section:hover {
    background-color: #efefef;
}

.sub-section i {
    float: right;
    margin-top: 7px;
    opacity: .3;
    font-size: 90%;
}

.sub-section-content {
    display: none;
    border: 1px solid #efefef;
    padding: 10px;
    border-radius: 2px;
}

.sub-section-content ul {
    margin-left: -10px;
}

.sub-section-content.selectedSubSection {
    display: block;
}

.logout-link {
    cursor: pointer;
}

.footer {
    width: 100%;
    position: fixed;
    height: 40px;
    bottom: 0px;
    left: 0px;
    background: rgb(224, 0, 43);
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
}

.jj-white {
    position: absolute;
    right: 70px;
    bottom: 10px;
    width: 30px;
    height: 30px;
}

.jj-help {
    position: absolute;
    right: 20px;
    bottom: 5px;
    width: 30px;
    height: 30px;
    font-size: 30px;
    opacity: .7;
}

.jj-white img {
    width: 100%;
    height: auto;
}

.alert-success {
    width: 320px;
    margin: 0 auto;
    margin-top: 40px;
    text-align: center;
}

.logout-container {
    width: 300px;
    clear: both;
    text-align: right;
    padding: 5px;
    color: black;
    position: absolute;
    right: 0px;
    top: 70px;
}

@media (max-width: 800px) {
    .quad-container {
        max-width: 96%;
    }
    .quad-card {
        width: 80%;
        height: auto;
        padding: 0px;
        margin: 0 auto;
        padding-bottom: 30px;
        clear: right;
    }
    .signup-container {
        width: 96%;
        margin-top: 50px;
        margin-bottom: 20px;
    }
    .left {
        float: none;
        margin: 0 auto;
    }
    .right {
        float: none;
        margin: 0 auto;
    }
    .jj-white {
        display:none;
    }
    .jj-help {
         right: 10px;
        opacity: .8;
    }
    .footer {
        font-size: 11px;
    }
    .logout-email {
        display: none;
    }
}

body.noscroll {
    position:fixed;
    overflow:hidden
}
</style>
